import { textblocks } from 'seal-ui-components';
import styled from 'styled-components';
import { theme } from '@Themes/themeOverriderFabric';
const { darkText } = theme.palette;

export const SuggestedClauseTitle = styled(textblocks.Heading1)({
    color: darkText
});
export const SearchBoxWrapper = styled.div({
    marginBottom: 8
});
